import React from 'react';
import { Bot } from 'lucide-react';

/**
 * Typing indicator (three bouncing dots)
 */
const ChatTypingIndicator = () => {
  return (
    <div className="flex gap-3 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-blue-500 flex items-center justify-center shadow-sm">
        <Bot className="w-6 h-6 text-white" />
      </div>
      <div className="bg-white border-2 border-gray-100 rounded-3xl px-6 py-4 shadow-sm">
        <div className="flex gap-1.5">
          <div className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-indigo-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default ChatTypingIndicator;
